import React, { useEffect, useState } from 'react';
import Skeleton from '../../../components/ui/Skeleton';

const SAAS_URL = 'https://api.cultaz.com/API/plans.php';

const FeatureBadge = ({ active }) => (
  <span className={`inline-block px-2 py-0.5 text-xs rounded ${active ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-600'}`}>{active ? 'Yes' : 'No'}</span>
);

const PricingComparison = ({ desktopPrice = 0 }) => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    fetch(SAAS_URL)
      .then(r => r.json())
      .then(data => {
        if (!mounted) return;
        if (data?.status && Array.isArray(data.plans)) setPlans(data.plans);
        else setError('Invalid SaaS plans response');
      })
      .catch(() => setError('Unable to load SaaS plans'))
      .finally(() => mounted && setLoading(false));
    return () => { mounted = false; };
  }, []);

  if (loading) return <div className="p-4 rounded-md bg-card"><Skeleton count={2} /></div>;
  if (error) return <div className="p-4 rounded-md bg-card text-destructive">{error}</div>;

  return (
    <section className="mt-8">
      <h3 className="text-lg font-medium">Compare with our SaaS plans</h3>
      <div className="mt-4 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {plans.map(plan => (
          <div key={plan.id} className="p-4 border rounded-md bg-white">
            <div className="flex items-baseline justify-between">
              <div>
                <div className="font-semibold capitalize">{plan.name}</div>
                <div className="text-sm text-muted-foreground">{plan.description}</div>
              </div>
              <div className="text-xl font-bold">₦{Number(plan.price).toLocaleString()}</div>
            </div>

            <div className="mt-3 space-y-2 text-sm">
              <div className="flex items-center justify-between"><span>POS</span><FeatureBadge active={plan.features?.pos?.active} /></div>
              <div className="flex items-center justify-between"><span>Products</span><div className="text-sm">{plan.features?.products?.active ? plan.features?.products?.value : '-'}</div></div>
              <div className="flex items-center justify-between"><span>Support</span><FeatureBadge active={plan.features?.support?.active} /></div>
              <div className="flex items-center justify-between"><span>Installable App</span><FeatureBadge active={plan.features?.installable_app?.active} /></div>
            </div>

            <div className="mt-4 flex gap-2">
              <a className="px-3 py-2 rounded-md bg-primary text-white text-sm" href="#buy">Choose</a>
              <a className="px-3 py-2 rounded-md border text-sm" href="#details">Details</a>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 rounded-md border bg-white">
        <div className="flex items-center justify-between">
          <div className="text-sm text-muted-foreground">Estimated Desktop license total</div>
          <div className="text-lg font-semibold">₦{Number(desktopPrice).toLocaleString()}</div>
        </div>
        <p className="text-xs text-muted-foreground mt-2">Compare the monthly desktop license estimate above with our SaaS subscriptions. Contact sales to bundle cloud sync and managed services.</p>
      </div>
    </section>
  );
};

export default PricingComparison;
